
export default {
    props: {
        background: {
            type: String,
            default: null
        }
    }
};
